// extracted by mini-css-extract-plugin
export default {"wrapper":"school-finder-field_wrapper"};